<p-sidebar [(visible)]="showaddUpdateModal" [position]="'right'" (onHide)="closePaymentDialogue()"
    [closeOnEscape]="false" [dismissible]="false" [style]="{width:'60rem'}">
    <ng-template pTemplate="header">
        <h3>{{context}} Payment</h3>
    </ng-template>
    <ng-template pTemplate="content">
        <app-receipt-add #payment [currentReceipt]="currentSelectedRecord"
            (changeModalStatus)="changeAddUpdateModelState($event)"></app-receipt-add>
    </ng-template>
</p-sidebar>

<app-receipt-list [paymentListData]="recordList"
    (changeModelStatus)="changeAddUpdateModelState($event)"></app-receipt-list>